import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeBookNotesFields {
  bookCode: EntryFieldTypes.Symbol
  name: EntryFieldTypes.Symbol
  bookNotes?: EntryFieldTypes.Array<EntryFieldTypes.AssetLink>
}

export type TypeBookNotesSkeleton = EntrySkeletonType<TypeBookNotesFields, 'bookNotes'>
export type TypeBookNotes<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeBookNotesSkeleton,
  Modifiers,
  Locales
>

export function isTypeBookNotes<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeBookNotes<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'bookNotes'
}

export type TypeBookNotesWithoutLinkResolutionResponse = TypeBookNotes<'WITHOUT_LINK_RESOLUTION'>
export type TypeBookNotesWithoutUnresolvableLinksResponse = TypeBookNotes<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeBookNotesWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeBookNotes<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeBookNotesWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeBookNotes<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeBookNotesWithAllLocalesAndWithoutUnresolvableLinksResponse<Locales extends LocaleCode = LocaleCode> =
  TypeBookNotes<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
